import React from 'react'
import { useUsername } from '../hooks/useUsername'

export const Username: React.FC = () => {
  const username = useUsername()
  if (username === undefined) return <span>Loading…</span>
  if (username === '') return <span>No username</span>
  return <span>{username}</span>
}
